/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, events: NonNullable<unknown> }} Intakeprocessedmany2Inputs */

const en_intakeprocessedmany2 = /** @type {(inputs: Intakeprocessedmany2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} files processed · ${i?.events} extracted`)
};

const pt_intakeprocessedmany2 = /** @type {(inputs: Intakeprocessedmany2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ficheiros processados · ${i?.events} extraídos`)
};

/**
* | output |
* | --- |
* | "{count} files processed · {events} extracted" |
*
* @param {Intakeprocessedmany2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const intakeprocessedmany2 = /** @type {((inputs: Intakeprocessedmany2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intakeprocessedmany2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_intakeprocessedmany2(inputs)
	return pt_intakeprocessedmany2(inputs)
});
export { intakeprocessedmany2 as "intakeProcessedMany" }